import React from 'react'
import { Modal } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { useHistory } from 'react-router-dom'
import { ClickPill, Pill, RouteItem, RouteItemBody, RouteItemTitle } from '../../../../components/RouteItemComponent'
import routes from '../../../../helpers/routes'
import useAuth from '../../../../hooks/useAuth'
import useModal from '../../../../hooks/useModal'
import { Order, SellOrderContext } from '../../../../providers/SellOrdersProvider'
import { formatMoney, toLocalDateFormat } from '../../../../utils/functions'
import PayOrderModal from '../../orders/PayOrderModal'
import { Box } from '../../../common/interfaces'

function PayableOrderItem({ order, boxes }: { order: Order, boxes: Box[] }) {
  const { user } = useAuth();
  const { fetch, payOrder } = React.useContext(SellOrderContext);
  const history = useHistory();
  const infoModal = useModal();
  const payModal = useModal();

  const handlePayment = async (data: { amount: number, boxId: string, date: string }) => {
    try {
      if (order) {
        await payOrder(order.id, data.amount, data.boxId, data.date);
        toast.success("Pago registrado");
        fetch();
      }
    } catch (e: any) {
      toast.error(e?.response?.data || 'Error al registrar pago');
      throw e;
    }
  }

  return (
    <>
      <RouteItem>
        <RouteItemTitle>
          <Pill>Nº {order.id}</Pill>
          <Pill>{order.documentNumber}</Pill>
          {order.user.role === 'vendedor' && <Pill>{order.user.username}</Pill>}
          <Pill>{toLocalDateFormat(order.deliveryDate)}</Pill>
          <Pill>{formatMoney(order.toPay)}</Pill>
          {user && user.role === 'admin' && !order.customer.watched && <ClickPill onClick={payModal.toogleModal}>Pagar</ClickPill>}
        </RouteItemTitle>
        <RouteItemBody onClick={infoModal.toogleModal}>
          {order.customer.name}
        </RouteItemBody>
      </RouteItem>
      <PayOrderModal show={payModal.isOpenModal} close={payModal.toogleModal} order={order} submitFunction={handlePayment} boxes={boxes} />
      <Modal show={infoModal.isOpenModal} onHide={infoModal.toogleModal}>
        <Modal.Header closeButton>
          <div style={{ fontWeight: 600 }}>Orden Nº {order.id}</div>
        </Modal.Header>
        <Modal.Body>
          <div>{order.futureDocument}</div>
          <div><b>Vendedor:</b> {order.user.username}</div>
          <div><b>Cliente:</b> {order.customer.name}</div>
          <div><b>Referencia:</b> {order.customer.reference}</div>
          <div><b>Total:</b> {formatMoney(order.total)}</div>
          <div><b>Falta pagar:</b> {formatMoney(order.toPay)}</div>
          <div>Detalle de la venta:</div>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid' }}>Producto</th>
                <th style={{ border: '1px solid' }}>Cantidad</th>
              </tr>
            </thead>
            <tbody>
              {order.items.map((item, index) => (
                <tr key={index}>
                  <td style={{ border: '1px solid' }}>{item.product_group.name}</td>
                  <td style={{ border: '1px solid' }}>{item.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-info' onClick={() => history.push(routes.ventas.ver(order.id))}>Ver Venta</button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default PayableOrderItem
